const postToMlsOptionItems = [
  {
    label: 'YES',
    value: true,
  },
  {
    label: 'NO',
    value: false,
  },
];

export default postToMlsOptionItems;
